import React, { createContext, useContext, useState } from "react";
import { postRequest, patchRequest } from "services/api";
import { ACTION_TYPES } from "utils/constants";

const TripCreateContext = createContext();

export const TripCreateProvider = ({ children }) => {
  // "name": "Label 1", // required
  // "default_availability": 100, // required | min : 1 | max : 10000
  // "start_time":"08:00",
  // "end_time":"10:00"
  const [trip, setTrip] = useState({
    form: {
      name: "",
      default_availability: 0,
      start_time: "",
      end_time: "",
    },
    data: null,
    loading: false,
    error: null,
    isSubmitting: false,
    mode: ACTION_TYPES.CREATE,
  });

  const createTrip = async () => {
    setTrip((prevState) => ({
      ...prevState,
      isSubmitting: true,
    }));

    try {
      const response = await postRequest("/trip", trip.form);
      console.log(response);
      if (response.success) {
        setTrip((prevState) => ({
          ...prevState,
          data: response.data,
          error: null,
          isSubmitting: false,
        }));

        return { success: true, data: response };
      }
    } catch (error) {
      setTrip((prevState) => ({
        ...prevState,
        error: "Failed to create trip",
        isSubmitting: false,
      }));

      return { success: false, error: error };
    }
  };

  const updateTrip = async (id) => {
    setTrip((prevState) => ({
      ...prevState,
      isSubmitting: true,
    }));

    try {
      const response = await patchRequest(`/trip/${id}`, trip.form);
      if (response.success) {
        setTrip((prevState) => ({
          ...prevState,
          data: response.data,
          error: null,
          isSubmitting: false,
        }));

        return { success: true, data: response };
      }
    } catch (error) {
      setTrip((prevState) => ({
        ...prevState,
        error: "Failed to update trip",
        isSubmitting: false,
      }));

      return { success: false, error: error };
    }
  };

  return (
    <TripCreateContext.Provider
      value={{
        trip,
        setTrip,
        createTrip,
        updateTrip,
      }}
    >
      {children}
    </TripCreateContext.Provider>
  );
};

export const useTripCreate = () => {
  const context = useContext(TripCreateContext);
  if (!context) {
    throw new Error("useTripCreate must be used within a TripCreateProvider");
  }
  return context;
};
